var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 7.8 13.7",
    style: {
      enableBackground: "new 0 0 7.8 13.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#BF5F13;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,6.9c0,0.2-0.1,0.5-0.3,0.6l-6,6c-0.2,0.3-0.8,0.2-1.1,0.1l-0.1-0.1l-0.1-0.1c-0.1-0.2-0.1-0.5-0.1-0.6 s0-0.4,0.1-0.6v-0.1l5.4-5.4L0.3,1.4C0.1,1.3,0,1.1,0,0.9s0.1-0.5,0.3-0.6C0.5,0.1,0.7,0,0.9,0s0.5,0.1,0.6,0.3l6,6 C7.7,6.4,7.8,6.6,7.8,6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightOrange);
export default __webpack_public_path__ + "static/media/chevron_right_orange.5ad84e2f6b103d1bd38e238b160af89c.svg";
export { ForwardRef as ReactComponent };